import { default as MuiTable, TableProps } from '@mui/material/Table'
import * as React from 'react'

type TableRef = HTMLElementTagNameMap['table']

// eslint-disable-next-line no-shadow
export const Table = React.forwardRef<TableRef, TableProps>(function Table(props, ref) {
  return <MuiTable ref={ref} {...props} />
})

export default Table
